import './DisconnectButton.css';

import React from 'react';

interface DisconnectButtonProps {
  onClick: () => void
  disabled?: boolean
}

export const DisconnectButton = ({ onClick, disabled = false }: DisconnectButtonProps): JSX.Element => {
  return (
    <button
      id="wifi_disconnection_disconnect_button"
      className="red-button"
      onClick={onClick}
      disabled={disabled}
    >
      Disconnect
    </button>
  );
};
